import { useSearchPageEscapeHatchPrefix } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/useSearchPageEscapeHatchPrefix";
import { useSearchPageIsFromDiscoverURL } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { useSearchPageIsOnFirstPage } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsOnFirstPage";
import { isLoggedInRetailer } from "@faire/marketplace-lib/serialized-data/isLoggedInRetailer";

export const useSearchPageShouldShowEscapeHatchText = () => {
  const isFromDiscoverURL = useSearchPageIsFromDiscoverURL();
  const isOnFirstPage = useSearchPageIsOnFirstPage();
  const escapeHatchPrefix = useSearchPageEscapeHatchPrefix();

  return (
    escapeHatchPrefix &&
    isOnFirstPage &&
    (isLoggedInRetailer() || isFromDiscoverURL)
  );
};
